<ion-header>
	<app-account-toolbar
		src="../../../assets/dean_and_david/burger-menu/registration.svg"
		[title]='!isAccount ?"sign_up.title" : "account.title"'
		(back)="goBack()"
	></app-account-toolbar>
</ion-header>
<ion-content>
	<ion-row *ngIf="!loading" class="ion-justify-content-center" role="region" aria-label="Centered content">
		<ion-col class="ion-padding ion-margin-top wrapper" size="12" size-lg="6" size-md="8" [formGroup]="signUpForm">
			<!-- <ion-radio-group formControlName="gender" [disabled]="loading">
				<ion-row role="region" aria-label="Content section">
					<ion-col class="ion-no-padding">
						<ion-item class="input no-line" lines="none">
							<ion-radio [value]="Gender.female" mode="md" slot="start"></ion-radio>
							{{ 'sign_up.female' | translate }}
						</ion-item>
					</ion-col>
					<ion-col class="ion-no-padding">
						<ion-item class="input no-line" lines="none">
							<ion-radio [value]="Gender.male" mode="md" slot="start"></ion-radio>
							{{ 'sign_up.male' | translate }}
						</ion-item>
					</ion-col>
					<ion-col class="ion-no-padding">
						<ion-item class="input no-line" lines="none">
							<ion-radio [value]="Gender.other" mode="md" slot="start"></ion-radio>
							{{ 'sign_up.diverse' | translate }}
						</ion-item>
					</ion-col>
				</ion-row>
			</ion-radio-group> -->

			<div class="error_container" role="region" aria-label="Error container">
				<ion-note class="input-error" [class.visible]="isValid('gender')" slot="error"
					>{{'sign_up.validation.gender' | translate}}</ion-note
				>
			</div>

			<ion-label class="stacked">{{ 'sign_up.name' | translate }}*</ion-label>
			<ion-item class="input ion-invalid" lines="none" [class.ion-info]="!isValid('fullName') && isValidByPattern('fullName')">
				<ion-input formControlName="fullName" name="name" type="text"></ion-input>
			</ion-item>
			<div class="error_container" role="region" aria-label="Error container">
				<ion-note class="input-error" [class.visible]="isValid('fullName')" slot="error"
					>{{'sign_in.required' | translate}}</ion-note
				>
				<ion-note class="input_info" [class.visible]="!isValid('fullName') && isValidByPattern('fullName')" slot="error"
					>{{'sign_up.validation.name' | translate}}</ion-note
				>
			</div>
			<ng-container *ngIf="!isAccount">
				<ion-label class="stacked">{{ 'sign_up.email' | translate }}*</ion-label>
				<ion-item class="ion-invalid" lines="none" [class.ion-info]="!isValid('email') && isValidByPattern('email')">
					<ion-input formControlName="email" name="email" type="email"></ion-input>
				</ion-item>
				<div class="error_container" role="region" aria-label="Error container">
					<ion-note class="input-error" [class.visible]="isValid('email')" slot="error"
						>{{'sign_in.required' | translate}}</ion-note
					>
					<ion-note class="input_info" [class.visible]="!isValid('email') && isValidByPattern('email')" slot="error"
						>{{'sign_up.validation.email' | translate}}</ion-note
					>
				</div>
			</ng-container>

			<div class="custom_phone container" role="region" aria-label="Custom phone container">
				<ion-label class="stacked">{{ 'checkout_modal.phone' | translate }} {{'sign_up.optional'|translate}}</ion-label>
				<ion-item class="ion-invalid item_input" lines="none" [class.ion-info]="!isValid('phone') && isValidByPattern('phone')">
					<app-input-phone-with-county-code formControlName="phone" [hasBackground]="false"></app-input-phone-with-county-code>
				</ion-item>
				<div class="error_container" role="region" aria-label="Error message container">
					<ion-note class="input-error" [class.visible]="isValid('phone')" slot="error"
						>{{ 'sign_up.validation.required' | translate }}</ion-note
					>
					<ion-note
						class="input_info"
						[class.visible]="
							!isValid('phone') && getErrorsForm('phone')?.invalidPhone && signUpForm.get('phone')?.dirty
						"
						slot="error"
						>{{ 'errors.phone' | translate }}</ion-note
					>
				</div>
			</div>
			<div class="container">
				<ion-label>{{ 'sign_up.birthday' | translate }} {{'sign_up.optional' | translate}}</ion-label>
				<ion-item
					class="input input-age"
					lines="none"
					[class.ion-info]="!isValid('fullName')
					&&
					isValidByPattern('fullName')"
				>
					<ion-input
						formControlName="day"
						placeholder="DD"
						type="tel"
						maxlength="2"
						#field1
						(keyup)="(field1.value.toString().length == 2) ?
						gotoNextField(field2): ''"
					></ion-input>
					<ion-input
						formControlName="month"
						type="tel"
						maxlength="2"
						placeholder="MM"
						#field2
						(keyup)="(field2.value.toString().length == 2)
						?
						gotoNextField(field3): ''"
					></ion-input>
					<ion-input formControlName="year" type="tel" maxlength="4" placeholder="YYYY" #field3></ion-input>
				</ion-item>
				<div class="error_container" role="region" aria-label="Error message container">
					<ion-note class="input-error" [class.visible]="isValid('day')" slot="error"
						>{{'sign_up.validation.required' | translate}}</ion-note
					>
					<ion-note class="input-error" [class.visible]="isValid('month')" slot="error"
						>{{'sign_up.validation.required' | translate}}</ion-note
					>
					<ion-note class="input-error" [class.visible]="isValid('year')" slot="error"
						>{{'sign_up.validation.required' | translate}}</ion-note
					>
					<ion-note
						class="input_info"
						[class.visible]="!isValid('day') &&
						isValidByPattern('day')"
						slot="error"
						>{{'sign_up.validation.date' | translate}}</ion-note
					>
					<ion-note
						class="input_info"
						[class.visible]="!isValid('month') &&
						isValidByPattern('month')"
						slot="error"
						>{{'sign_up.validation.month' | translate}}</ion-note
					>
					<ion-note
						class="input_info"
						[class.visible]="!isValid('year') &&
						isValidByPattern('year')"
						slot="error"
						>{{'sign_up.validation.year' | translate}}</ion-note
					>
				</div>
			</div>
			<ng-container *ngIf="!isAccount">
				<ion-label class="stacked">{{ 'sign_up.company_code' | translate }}</ion-label>
				<ion-item class="ion-invalid" lines="none">
					<ion-input formControlName="dnd_code" name="dnd_code" type="text"></ion-input>
				</ion-item>
				<div class="error_container" *ngIf="dnd_codeInvalid" role="region" aria-label="Error message container">
					<ion-note class="input-error">This code is not valid...</ion-note>
				</div>
			</ng-container>

			<ng-container *ngIf="!isAccount">
				<ion-label class="stacked">{{ 'sign_up.password' | translate }}*</ion-label>
				<ion-item class="input" lines="none" [class.ion-info]="!isValid('password') && isValidByPattern('password')">
					<ion-input formControlName="password" [type]="showPassword ? 'text' : 'password'" name="password"></ion-input>
					<ion-icon
						(click)="showPassword = !showPassword"
						[src]="showPassword ? '/assets/dean_and_david/eye.svg' : '/assets/dean_and_david/eye_dis.svg'"
						class="eye-icon pointer"
						slot="end"
						role="button"
						aria-label="Toggle password visibility"
					></ion-icon>
				</ion-item>
				<div class="error_container_highter" role="region" aria-label="Error container">
					<ion-note class="input-error" [class.visible]="isValid('password')" slot="error"
						>{{'sign_in.required' | translate}}</ion-note
					>
					<ion-note class="input_info" [class.visible]="!isValid('password') && isValidByPattern('password')" slot="error"
						>{{'sign_up.validation.password' | translate}}</ion-note
					>
				</div>

				<ion-label class="stacked">{{ 'sign_up.re_password' | translate }}*</ion-label>
				<ion-item class="input" lines="none" [class.ion-info]="!isValid('rePassword') && isValidByPattern('rePassword')">
					<ion-input formControlName="rePassword" [type]="showRePassword ? 'text' : 'password'" name="password"></ion-input>
					<ion-icon
						(click)="showRePassword = !showRePassword"
						[src]="showRePassword ? '../../../assets/dean_and_david/eye.svg' : '../../../assets/dean_and_david/eye_dis.svg'"
						class="eye-icon pointer"
						slot="end"
						role="img"
						aria-label="Toggle password visibility"
					></ion-icon>
				</ion-item>
				<div class="error_container" role="region" aria-label="Error message container">
					<ion-note class="input-error" [class.visible]="isValid('rePassword')" slot="error"
						>{{'sign_in.required' | translate}}</ion-note
					>
					<ion-note
						class="input_info"
						[class.visible]="!isValid('rePassword') && signUpForm.get(this.rePassword).errors?.['confirmedValidator']"
						slot="error"
						>{{'sign_up.validation.re_password' | translate}}</ion-note
					>
				</div>

				<ion-item class="terms input no-line" lines="none">
					<ion-checkbox formControlName="agbChecked" mode="md"></ion-checkbox>
					<ion-label class="ion-text-wrap">
						<ion-row class="privacy" role="region" aria-label="Privacy section">
							{{ 'sign_up.accept' | translate }}
							<ion-button
								(click)="openTerms()"
								class="underline pointer content-only privacy-btn"
								aria-label="Open terms and conditions"
							>
								{{ 'sign_up.privacy' | translate }}.
							</ion-button>
						</ion-row>
					</ion-label>
				</ion-item>
			</ng-container>
			<div class="button-wrapper" *ngIf="!isAccount" role="region" aria-label="Button wrapper">
				<ion-button class="google" (click)="signUpWithGoogle()" aria-label="Sign up with Google">
					<ion-icon src="../../../assets/dean_and_david/google.svg" role="img" aria-label="Google logo"></ion-icon>
					<p>Weiter mit Google</p>
				</ion-button>
				<ion-button class="facebook" (click)="signUpWithFacebook()">
					<ion-icon src="../../../assets/dean_and_david/facebook.svg" role="img" aria-label="Facebook icon"></ion-icon>
					<p>Weiter mit Facebook</p>
				</ion-button>
				<ion-button class="apple" (click)="signUpWithApple()">
					<ion-icon src="../../../assets/dean_and_david/apple.svg" role="img" aria-label="Apple icon"></ion-icon>
					<p>Mit Apple anmelden</p>
				</ion-button>
			</div>
		</ion-col>
	</ion-row>
	<ion-row *ngIf="loading" class="ion-justify-content-center block loading" role="region" aria-label="Loading content">
		<ion-spinner color="primary"></ion-spinner>
	</ion-row>
</ion-content>
<ion-footer *ngIf="!loading">
	<ion-row class="ion-justify-content-center">
		<ion-col class="ion-padding" size="12" size-lg="4" size-md="6">
			<ion-button (click)="signUp()" [disabled]="isValid()" expand="block" *ngIf="!isAccount"
				>{{ 'sign_up.reg' | translate }}</ion-button
			>
			<ion-button (click)="update()" [disabled]="isValid()" expand="block" *ngIf="isAccount"
				>{{ 'account.save' | translate }}</ion-button
			>
		</ion-col>
	</ion-row>
</ion-footer>
